export enum StorageCargoActionTypes {
  STORAGE_GET_RATES = "STORAGE_GET_RATES",
  STORAGE_SET_CARGO_TYPE = "STORAGE_SET_CARGO_TYPE",
  STORAGE_SET_ESTIMATED_NUM_OF_PALLETS = "STORAGE_SET_ESTIMATED_NUM_OF_PALLETS",
  STORAGE_SET_NUM_OF_PALLETS = "STORAGE_SET_NUM_OF_PALLETS",
  STORAGE_SET_CONTAINER_ID = "STORAGE_SET_CONTAINER_ID",
  STORAGE_SET_CONTAINER_SIZE = "STORAGE_SET_CONTAINER_SIZE",
  STORAGE_RESET_CARGO_TYPE = "STORAGE_RESET_CARGO_TYPE",
}
